import Swiper from "swiper";
import "swiper/css";

const swiper = () => {

    const swiper = new Swiper(".swiper-container", {
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
    });

    console.log("Swiper initialized:", swiper);

};

export default swiper;
